import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateBgWave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 480,
	height: 480,
	viewBox: "0 0 480 480",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1704_5065",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 480,
			height: 480,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 480,
				height: 480,
				fill: "url(#paint0_radial_1704_5065)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1704_5065)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 47.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 79.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 111.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 143.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 143.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 175.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 207.5,
					stroke: "#E9EAEB"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240,
					cy: 240,
					r: 239.5,
					stroke: "#E9EAEB"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_1704_5065",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(240 240) rotate(90) scale(240 240)",
			children: [/* @__PURE__ */ _jsx("stop", {}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgEmptyStateBgWave;
